
export default {
  data: () => ({
    idForm: "0heb2w06",
    isSticky: false,

    isMobile: false,
    potentials: [
      {
        icon: require("~/assets/img/icon-satellite.png"),
        alt: "icone yeux etoile",
        title: "+ de 15 000 entreprises",
        text: "propulsées dans leur communication",
      },
      {
        icon: require("~/assets/img/icon-idee.png"),
        alt: "icone ampoule allumé",
        title: "+ de 5 000 sites web",
        text: "conçus par nos équipes de webdesign",
      },
      {
        icon: require("~/assets/img/icon-orbit.png"),
        alt: "icone licorne",
        title: "+ de 100 métiers",
        text: "différents accompagnés chaque jour",
      },
    ],
    offerItems: [
      {
        title: "Site web",
        price: "49€",
        perMonth: true,
        text: `Booster son activité grâce à un site <br class="hidden lg:block"> web clés en main.`,
        link: "web",
        img: "offer-web.webp",
        alt: "Exemple de site internet",
      },
      {
        title: "Réseaux sociaux",
        price: "290€",
        perMonth: true,
        text: `Développer sa notoriété et gagner en <br class="hidden lg:block"> crédibilité pour attirer de nouveaux clients.`,
        link: "gestion-rs",
        img: "offer-cm.png",
        alt: "Exemples de posts Facebook ou Instagram",
      },
      {
        title: "Publicité Google",
        price: "299€",
        perMonth: true,
        text: `Générer plus de contacts en <br class="hidden lg:block"> devenant plus visible sur Google.`,
        link: "seo",
        img: "offer-seo.webp",
        alt: "Landing page campagne Google Ads",
      },
      {
        title: "Graphisme",
        price: "199€",
        perMonth: false,
        text: `Créer un logo à son image et tous les supports <br class="hidden lg:block"> nécessaires (cartes de visite, brochure...)`,
        link: "graphism",
        img: "offer-graphism.webp",
        alt: "Exemple de cartes de visite et logo ALEO",
      },
    ],
    timeline: {
      surtitle: null,
      title: `Comment <span class="font-bold font-clash">parrainer</span> ?`,
      steps: [
        {
          img: "parrainage-step-1.png",
          title: "Complétez le formulaire",
          text: "Remplissez le formulaire avec vos coordonnées et celles de votre filleul.",
          alt: "Complétez le formulaire",
          picto: "picto-parrainage-1.png",
        },
        {
          img: "parrainage-step-2.png",
          title: "Nous envoyons un mail à votre filleul",
          text: "Un mail sera envoyé à votre filleul pour lui indiquer qu’un conseiller ALEO va le contacter de votre part.",
          alt: "Envoi mail",
          picto: "picto-parrainage-2.png",
        },
        {
          img: "parrainage-step-4.png",
          title: "Nous appelons votre filleul",
          text: "Votre contact confie sa communication à ALEO et bénéficiera de tarifs préférentiels grâce à vous.",
          alt: "Appel filleul",
          picto: "picto-parrainage-3.png",
        },
        {
          img: "parrainage-step-3.png",
          title: "Vous recevez votre cadeau",
          text: "Une fois son devis signé, vous recevrez 100€ par virement bancaire.",
          alt: "Logo livrable en différents formats",
          picto: "picto-parrainage-4.png",
        },
      ],
    },
    questions: [
      {
        question: "Qui peut parrainer ?",
        answer:
          "N’importe qui peut parrainer une entreprise. Si vous êtes un professionnel ou un particulier et que vous souhaitez accompagner des personnes de votre entourage ou réseau professionnel dans l’amélioration de leur visibilité en ligne, vous pouvez devenir parrain chez ALEO.",
        isCollapsed: false,
      },
      {
        question: "Qui peut être parrainé ?",
        answer:
          "Tous les entrepreneurs français peuvent être parrainés. Si une personne de votre entourage débute son activité en tant qu’indépendant ou a déjà une entreprise implantée, vous pouvez la parrainer chez ALEO.",
        isCollapsed: false,
      },
      {
        question: "Y a-t-il une limite au nombre de parrainages ?",
        answer: "Vous pouvez parrainer jusqu’à 10 professionnels par mois.",
        isCollapsed: false,
      },
      {
        question: "Comment serai-je notifié de la signature de mon contact ?",
        answer:
          "Lorsque votre contact aura choisi son offre ALEO, vous recevrez un mail vous indiquant la procédure à suivre pour récupérer vos 100€ !",
        isCollapsed: false,
      },
      {
        question: "Comment vais-je recevoir ma prime ?",
        answer:
          "Une fois votre contact accompagné par ALEO et le premier prélèvement effectué, vous recevrez vos 100€ par virement bancaire.",
        isCollapsed: false,
      },
      {
        question: "Quel est le montant de la prime ?",
        answer:
          "Pour chaque contact que vous nous transférez et qui désire passer par ALEO pour sa communication, vous gagnez 100€. Vous pouvez parrainer jusqu’à 10 professionnels par mois et donc gagner jusqu’à 1000€ TTC.",
        isCollapsed: false,
      },
      {
        question: "Quelles informations sont requises ?",
        answer: `Pour transmettre un contact à ALEO, nous aurions besoin de différentes informations.<br>
          Tout d’abord, concernant la personne que vous souhaitez faire accompagner par ALEO :
          <ul>
            <li>
            - Son nom et prénom
           </li>
           <li>
            - Le nom de son entreprise
           </li>
           <li>
            - Le numéro de téléphone de son entreprise
           </li>
           <li>
            - Son adresse mail
           </li>
          </ul>
          <br>
          Ensuite, nous aurions besoin de vos coordonnées pour pouvoir vous recontacter :
          <ul>
            <li>
            - Votre nom et prénom
           </li>
           <li>
            - Votre adresse mail
           </li>
           <li>
            - Votre numéro de téléphone.
           </li>
          </ul>
          <br>
          Ces informations nous permettront de vous recontacter afin de vous faire parvenir votre prime de parrainage !
          `,
        isCollapsed: false,
      },
      {
        question: "Est-ce que je peux m’auto-parrainer ?",
        answer:
          "Vous ne pouvez pas vous parrainer vous-même pour obtenir à la fois votre cadeau et les frais de création offerts.",
        isCollapsed: false,
      },
      {
        question: "Je n’ai pas reçu ma prime de parrainage.",
        answer: `Si vous avez transmis un contact à ALEO et que vous n’avez pas reçu votre prime, c’est que votre contact n’a pas désiré faire appel à ALEO pour sa communication ou que nous n’avons pas pu le joindre. <br>
Sinon, votre virement bancaire est généralement effectué un mois après l’adhésion de votre contact à une offre ALEO. <br>
Pour toute question, contactez-nous en utilisant notre formulaire de contact. <br>
`,
        isCollapsed: false,
      },
    ],
    webNews: [
      {
        link: "https://www.lefigaro.fr/services/aleo-l-agence-web-n01-dans-la-creation-de-sites-internet-pour-les-tpe-pme-20210716",
        img: require("~/assets/img/logo-le-figaro.svg"),
        alt: "logo le figaro",
      },
      {
        link: "https://www.bfmtv.com/economie/professionnels/aleo-l-agence-de-communication-pour-tpe-pme-qui-va-propulser-votre-activite_AN-202107290333.html",
        img: require("~/assets/img/logo-bfm-business.svg"),
        alt: "logo BFM Business",
      },
      {
        link: "https://www.challenges.fr/entreprise/aleo-l-agence-de-communication-100-dediee-aux-tpe-pme_773971",
        img: require("~/assets/img/logo-challenges.svg"),
        alt: "logo Challenges",
      },
      {
        link: "https://www.latribune.fr/supplement/comment-l-agence-web-aleo-souhaite-booster-la-presence-en-ligne-des-tpe-pme-890514.html",
        img: require("~/assets/img/logo-la-tribune.svg"),
        alt: "logo la tribune",
      },
      {
        link: "https://www.forbes.fr/brandvoice/10000-entreprises-conquises-pour-aleo-lagence-web-n1-des-tpe-pme/",
        img: require("~/assets/img/logo-forbes.svg"),
        alt: "logo Forbes",
      },
    ],
  }),
  head() {
    return {
      title: "Faire du parrainage avec ALEO L’Agence de Communication des pros",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez le programme de parrainage d'ALEO : recommandez nos services et recevez des récompenses exclusives pour chaque nouveau client apporté, une aubaine !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "ALEO - L’Agence de Communication des pros",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "L’Agence de Communication des pros. Indépendants, petites et moyennes entreprises, découvrez ALEO, l’offre qui booste votre activité.",
        },
      ],
    };
  },
  computed: {
    bgAmbassador() {
      return this.$img.getSizes("bg-experts.png", {
        sizes: "xs:1440px",
        modifiers: {
          format: "webp",
        },
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.mobileMathMedia();
  },

  methods: {
    onScroll(e) {
      const header = this.$refs.header;
      const sticky = header.offsetTop;

      if (window.pageYOffset > sticky) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },

    mobileMathMedia() {
      if (window.matchMedia("(max-width: 767px)").matches) {
        this.isMobile = true;
      }
    },

    scrollSmooth() {
      document.documentElement.style.scrollBehavior = "smooth";
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = "unset";
      }, 1000);
    },

    toggleVideo() {
      this.$refs.video.togglePopup();
    },
  },
};
